"use client";

import Container from "@/components/atom/Container";
import { ChevronDownSvg, ChevronUpSvg } from "@/public/svg";
import { useState } from "react";
import SideNav from "../_component/SideNav";

const listSK = [
  {
    title: "Pengumpulan Informasi",
    desc: "Kami mengumpulkan informasi dari Anda ketika Anda mendaftar pada situs gudangonlinenibras.co.id, masuk ke akun Anda, melakukan pembelian, ikut dalam kontes, dan/atau ketika Anda keluar. Data yang dikumpulkan mencakup nama Anda, alamat email, nomor whatsapp, dan nomor rekening bank. <br/> <br/> Selain itu, kami menerima dan merekam informasi secara otomatis dari komputer dan peramban Anda, termasuk alamat IP Anda, perlengakapan perangkat keras dan lunak Anda, dan halaman yang Anda minta. ",
  },
  {
    title: "Penggunaan Informasi",
    desc: `Informasi yang kami kumpulkan dari Anda dapat digunakan untuk salah satu tujuan berikut: <br/>
    - Memproses transaksi <br/>
    - Memperbaiki layanan pelanggandan mendukung kebutuhan anda<br/>
    - Mengirimkan email berkala terkait pesanan atau layanan lainnya<br/>
    - Menyelenggarakan promosi, survei, atau fitur situs lainnya<br/>
    - Personalisasi pengalaman dan tanggapan anda sesuai kebutuhan pribadi anda<br/>
    - menyediakan konten iklan yang disesuaikan untuk meningkatkan pelayanan di situs website kami`,
  },
  {
    title: "Privasi E-Dagang",
    desc: "Informasi pribadi Anda yang terkait dengan transaksi e-dagang dijaga kerahasiaannya. Kami menerapkan berbagai langkah keamanan untuk memastikan keamanan informasi pribadi Anda ketika Anda melakukan pemesanan atau memasukkan, mengirimkan, atau mengakses informasi pribadi Anda. Informasi anda yang dikumpulkan tidak akan dijual, dipertukarkan, ditransfer, atau diberikan kepada Perusahaan lain dengan alasan apapun juga.",
  },
  {
    title: "Pengungkapan Pihak Ketiga",
    desc: "Kami tidak menjual, memperdagangkan, atau mentransfer informasi pribadi Anda kepada pihak luar. Hal ini tidak termasuk pihak ketiga terpercaya yang membantu kami dalam mengoperasikan situs web kami, menjalankan bisnis kami, atau melayani Anda, selama pihak tersebut setuju untuk menjaga kerahasiaan informasi ini. Kami juga dapat merilis informasi Anda ketika kami percaya rilis tersebut sesuai untuk mematuhi hukum, menegakkan kebijakan situs kami, atau melindungi hak, properti, atau keselamatan kami atau orang lain.",
  },
  {
    title: "Perlindungan Informasi",
    desc: `Kami menerapkan berbagai langkah keamanan untuk menjaga keamanan informasi pribadi Anda. Kami menawarkan penggunaan server yang aman. Semua informasi sensitif/kredit yang disuplai dienkripsi melalui Teknologi Secure Socket Layer (SSL) dan kemudian dienkripsi ke dalam database penyedia gateway pembayaran kami hanya untuk diakses oleh mereka yang berwenang dengan hak akses khusus ke sistem tersebut, dan diwajibkan untuk menjaga kerahasiaan informasi tersebut. <br/> <br/> 
    www.gudangonlinenibras.co.id memungkinkan bekerjasama dengan pihak ketiga yang memerlukan penegerjaan khusus (contohnya penagihan, layanan pelanggan, atau pengiriman;kurir) dan mereka diberikan akses informasi pribadi terkait. Komputer/server yang digunakan untuk menyimpan informasi pribadi yanbg dapat diidentifikasi disimpan dalam lingkungan yang aman. <br/><br/>
    Apakah kami menggunakan Kuki? <br/>
    Ya, kami menggunakan kuki meningkatkan akses ke situs kami dan mengenali pengunkung yang Kembali lagi. Lagi pula, kuki kami memperkaya pengalaman pengguna dengan melacak dan menarget minat mereka, namun, penggunaan kuki ini tidak mungkin terkait dengan informasi pribadi yang dapat diidentifikasi pada situs kami.`,
  },
  {
    title: "Berhenti Berlangganan",
    desc: `Kami menyediakan pilihan untuk berhenti berlangganan dari menerima email dan pesan pembaharuanmenyangkut pesanan anda, berita berkala dan lain lain di masa mendatang pada setiap email atau pesan whatsapp yang kami kirimkan, melalui link berhenti berlangganan di bagian bawah email tersebut.`,
  },
  {
    title: "Persetujuan",
    desc: `Dengan menggunakan situs kami, Anda menyetujui Pemberitahuan Privasi kami. <br/>
    Jika anda memiliki pertanyaan terkait privacy policy, silahkan menghubungi whatsapp customer care wa.me/628118046243
    `,
  },
  {
    title: "Kontak Kami",
    desc: `Jika Anda memiliki pertanyaan mengenai Pemberitahuan Privasi ini, Anda dapat menghubungi kami melalui informasi kontak yang disediakan di situs web kami.`,
  },
  {
    title: "Perubahan pada Pemberitahuan Privasi Kami",
    desc: `Kami berhak memodifikasi Pemberitahuan Privasi ini kapan saja, jadi silakan tinjau secara berkala. Perubahan dan klarifikasi akan segera berlaku setelah diposting di situs web. Jika kami membuat perubahan materi pada kebijakan ini, kami akan memberi tahu Anda di sini bahwa telah diperbarui, sehingga Anda akan mengetahui informasi apa yang kami kumpulkan, bagaimana kami menggunakannya, dan di bawah keadaan apa, jika ada, kami menggunakannya dan/atau mengungkapkannya.`,
  },
];

export default function Privacy() {
  const [show, setShow] = useState({});
  return (
    <Container
      showMQ={false}
      className={"relative"}>
      <div className='flex px-gon w-screen gap-10 bg-shadesGON-50 my-6'>
        <SideNav />
        <div className='flex w-full flex-col gap-4'>
          <p className='h4-semiBold text-greyscaleGON-700'>
            Pemberitahuan Privasi
          </p>
          <div>
            {listSK?.map((item, index) => {
              return (
                <div
                  key={index}
                  className='flex flex-col gap-2 w-full border-b border-b-greyscaleGON-200'>
                  <div
                    onClick={() =>
                      setShow((old) => ({ ...old, [index]: !show?.[index] }))
                    }
                    className='flex flex-row justify-between items-center w-full p-4 cursor-pointer select-none'>
                    <p className='p1-bold text-greyscaleGON-700 uppercase'>
                      {item?.title}
                    </p>
                    {show?.[index] ? (
                      <ChevronDownSvg className='h-4 w-4' />
                    ) : (
                      <ChevronUpSvg className='h-4 w-4' />
                    )}
                  </div>
                  {show?.[index] && (
                    <div className='px-4 pb-8 select-none'>
                      <p
                        className='p2-regular text-greyscaleGON-700'
                        dangerouslySetInnerHTML={{ __html: item?.desc }}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className='pt-4'>
            <p className='p2-regular text-greyscaleGON-400'>
              Last Update: 13/12/2023
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}
